import { Button, Container, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

const NotFound = () => {
  return (
    <Container
      h="100vh"
      alignItems="stretch"
      justifyContent="center"
      textAlign="center"
      maxW="sm"
      centerContent
    >
      <Text
        fontSize="8xl"
        color="main.accent"
        fontWeight="bold"
        lineHeight="1"
        mb={4}
      >
        404
      </Text>
      <Text fontSize="md">Ups!</Text>
      <Text fontSize="md">Nie znaleziono strony.</Text>
      <Button
        as={Link}
        to="/"
        color="main.accent"
        borderColor="main.accent"
        variant="outline"
        mt={4}
      >
        Wróć
      </Button>
    </Container>
  )
}

export default NotFound
